import { IResultStamp } from "@/api/AppApi/common-interfaces/IResultStamp";
import { IBrand } from "../../home/interfaces/IBrands";
import { ICategory } from "../../home/interfaces/ICategory";
import {
  DiscountTypes,
  IProduct,
  Ratings,
} from "../../home/interfaces/IProduct";
import { IFilter } from "../../filters/interfaces/IGetFilters";
import { IField } from "../../builder/interfaces/interfaces";
import { IEventCustomData } from "../../home/IEvent";
import { IBundleItem } from "./product-bundle-types";

export interface IGetProductDetailsParams {
  id?: number | string | null;
}
export interface IProductImage {
  image_url: string;
  thumbnail_url: string;
  type?: "image" | "video";
}
export enum SpecificationTypes {
  text = "text",
  color = "color",
  image = "image",
  editor = "editor",
}
export interface ISpecification {
  key: string;
  type: SpecificationTypes;
  value: any;
}
export interface ISpecificationGroup {
  title: string;
  data: ISpecification[];
}
export enum AddOnTypes {
  checkbox = "checkbox",
  dropdown = "dropdown",
  card = "card",
}
export interface IAddOnConfiguration {
  is_multi_select: boolean;
  is_required: boolean;
  key: string;
  maximum_selected_addons: number;
  title: string;
  type: AddOnTypes;
  max_quantity: number | null;
  min_quantity: number | null;
}
export interface IAddOnData {
  id: number;
  image: string | null;
  name: string;
  price: number;
  quantity: number | null;
  enable_quantity_selection: boolean;
  key: string;
  max_quantity: number | null;
  min_quantity: number | null;
}
export interface IProductAddOn {
  type: "addon";
  configurations: IAddOnConfiguration;
  data: IAddOnData[];
}
export enum AttachmentTypes {
  files = "files",
  voices = "voices",
}
export enum ProductPreviewTypes {
  general = "general",
  consultation = "consultation",
  appointment = "appointment",
  event = "event",
  bundle = "bundle-products",
}
type customData = {
  term_and_condition: string;
  redirect_to_checkout?: boolean;
};
export type unit = {
  id: number;
  name: string;
  price: number;
  price_without_discount: number;
  max_quantity_in_cart?: number;
  min_quantity_in_cart?: number;
  discount_amount: number;
  discount_type?: DiscountTypes;
  discount?: number;
};
export interface ICommonProductDetails {
  addons_builder: IProductAddOn[];
  attributes_builder: IFilter[];
  attribute_ids: number[];
  brand: IBrand;
  categories: ICategory[];
  children: IProductDetails[];
  custom_data: customData | IEventCustomData | any;
  description: string;
  discount: number;
  discount_amount: number;
  discount_type: DiscountTypes;
  has_discount: boolean;
  has_required_addons: boolean;
  id: number;
  image_url: string;
  images: IProductImage[];
  is_configurable: boolean;
  is_favorite: boolean;
  is_new: boolean;
  long_description: any;
  max_quantity_in_cart: number | null;
  min_quantity_in_cart: number | null;
  name: string;
  parent_id: number | null;
  preview_type: ProductPreviewTypes;
  price: number;
  price_without_discount: number;
  quantity_on_hand: number;
  rate: number;
  sharable_text: string;
  sku: string;
  slug: string;
  specifications: ISpecificationGroup[];
  thumbnail_url: string;
  fields_builder: IField[];
  unit_id: number;
  units: unit[];
  has_configurable_parent: boolean;
  selling_prices: IProduct["selling_prices"];
  meta: ProductDetailsMeta;
  ratings: Ratings;
  can_review: boolean;
  show_note_field: boolean | number; // 0 or 1
  categories_names?: string[];
  bundle_items?: IBundleItem[];
  has_required_fields: boolean;
  has_term_and_condition: boolean;
  sold_quantity:number
}
export interface IProductDetails extends ICommonProductDetails {
  preview_type: ProductPreviewTypes.general;
  robosize_id: string;
  robosize_domain: string;
}
export interface IAppointmentDetails extends ICommonProductDetails {
  preview_type: ProductPreviewTypes.appointment;
}
export interface IConsultDetails extends ICommonProductDetails {
  preview_type: ProductPreviewTypes.consultation;
  custom_data: customData & {
    allowed_attachment: AttachmentTypes[];
    done_after: string;
    msg_limit: string;
    reply_limit: string;
  };
}
export interface IGetProductDetails extends IResultStamp {
  result?: IProductDetails;
}

export interface ProductDetailsMeta {
  meta_title: string;
  meta_keyword: string;
  meta_description: string;
  og_title: string;
  og_description: string;
  og_image_url: string;
}
export interface IGetProductSEOData extends IResultStamp {
  result?: ProductDetailsMeta;
}
